export default {
    top_menu: [
        {name:'घर',    id:0},
        {name:'शो बिजनेस', id:1},
        {name:'खाना बनाना',  id:2},
        {name:'राजनीति',   id:3},
        {name:'सरस',  id:4},
        {name:'समाज',   id:5},
        {name:'स्वास्थ्य',   id:6},
    ],
    read_other: 'अन्य पढ़ें',
    read_more:  'और पढ़ें',
    not_found:  'नहीं मिला',
    read_also:  'ये भी पढ़ें',
    copy_rights: 'कॉपीराइट © 2019 «mixer-novostei.ru». सर्वाधिकार सुरक्षित',
    subscribe: 'सदस्यता लें',

    thank_order: 'आदेश के लिए धन्यवाद',
    specialist_contact: 'हमारा विशेषज्ञ जल्द ही आपसे संपर्क करेगा, हमारी कॉल की प्रतीक्षा करें',
    attention: 'ध्यान',
    we_value_customers: 'हम अपने प्रत्येक ग्राहक को महत्व देते हैं, इसलिए हम आपके लिए विशेष कीमत पर विशेष उत्पाद भी पेश करना चाहते हैं।',
    hurry: 'जल्दी करें, छूट का सक्रियण समय सीमित है! You have only <span id="time" class="time">30:00</span> इन अनूठे उत्पादों में से किसी एक को चुनने के लिए मिनट:',

    hour_ago1: "घंटेभर पहले",
    hour_ago2: "घंटेभर पहले",
    hour_ago3: "घंटेभर पहले",
    new_publications: "नई पोस्ट",
    read: "पढ़ना",
    today_at: "आज में",
    author_names: ['Elena Klimova','Mariia Andreeva','Irina Klimenko'],
    main_news: "मुख्य समाचार",
    leave_already: "पहले ही जा रहे हैं? हमारे द्वारा अपडेट की गई खबर की प्रतीक्षा करें",
    already_shared: "पहले ही साझा किया जा चुका है"

}